export enum DataFilterType {
  Select = 'Select',
  DateRange = 'DateRange',
  Text = 'Text',
}

export enum DataFilterOperation {
  Equal = 'Equal',
  NotEqual = 'NotEqual',
  InRange = 'InRange',
  LessThan = 'LessThan',
  GreaterThan = 'GreaterThan',
}

export const DataFilterOperationDisplay = {
  Equal: { label: 'is' },
  NotEqual: { label: 'is not' },
  InRange: { label: 'is in range' },
  LessThan: { label: 'is less than' },
  GreaterThan: { label: 'is greater than' },
} as const;

export interface DataFilterCacheConfig {
  ttlSeconds: number;
}

export interface DataFilter<Data, TSchema> {
  id: string;
  label: string;
  type: DataFilterType;
  operations: DataFilterOperation[];
  selectOptions?: (data?: Data) => Promise<DropdownOption[]>;
  /**
   * Opt-in caching for `selectOptions`. When set, the calling context
   * (e.g. `getQueueListFilters`) may cache the result keyed by filter id
   * and the `data` argument. Filters whose options are static or cheap
   * to compute should leave this unset.
   */
  selectOptionsCache?: DataFilterCacheConfig;
  getMongoFilter: (data: Data, operation: DataFilterOperation) => Partial<TSchema> | object | undefined;
}

export interface DataFilterDisplay {
  id: string;
  label: string;
  description?: string;
  type: DataFilterType;
  displayValuePrefix?: string;
  displayValueSuffix?: string;
  operations: DataFilterOperation[];
  selectOptions?: DropdownOption[];
}

export interface AppliedDataFilter {
  id: string;
  selectedValues?: string[];
  operation?: DataFilterOperation;
}

export interface DropdownOption {
  value: string;
  label: string;
  group?: string;
}
